import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Component } from 'react';

interface AutoCloseProps {
  locked?: boolean;
}

interface AutoCloseState {
  expanded: boolean;
}

export default function withAutoClose(
  WrappedComponent: new (...props: any[]) => Component<any, any, any>
) {
  return class WithAutoClose extends Component<
    AutoCloseProps & any,
    AutoCloseState
  > {
    private wrapperRef: any;
    constructor(props: any) {
      super(props);

      this.state = {
        expanded: false
      };

      this.setWrapperRef = this.setWrapperRef.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.handleTriggerVisibility = this.handleTriggerVisibility.bind(this);
      this._checkAndSetLock = this._checkAndSetLock.bind(this);
    }

    componentDidMount() {
      this._checkAndSetLock(this.props);
      document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillReceiveProps(newProps: any) {
      this._checkAndSetLock(newProps);
    }

    componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node: any) {
      this.wrapperRef = ReactDOM.findDOMNode(node) as Element;
    }

    handleTriggerVisibility(visible: boolean) {
      this.setState({ expanded: visible });
    }

    _checkAndSetLock(props: any) {
      if (props.locked) {
        this.setState({ expanded: true });
        return true;
      } else {
        return false;
      }
    }

    handleClickOutside(event: any) {
      const { expanded } = this.state;
      if (!this._checkAndSetLock(this.props)) {
        if (
          expanded &&
          this.wrapperRef &&
          !this.wrapperRef.contains(event.target)
        ) {
          this.setState({ expanded: false });
        } else if (
          !expanded &&
          this.wrapperRef &&
          this.wrapperRef.contains(event.target)
        ) {
          this.setState({ expanded: true });
        }
      }
    }

    render() {
      return (
        <WrappedComponent
          ref={this.setWrapperRef}
          {...this.props}
          {...this.state}
          triggerVisibility={this.handleTriggerVisibility}
        />
      );
    }
  };
}
